// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionHeader_wrapper__oSOK2","title":"SectionHeader_title__abu6f","link":"SectionHeader_link__3H0-S"};